const _excluded = ["setEnabled"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { fetchWithTokenAndRegion, getAdminApiUrl, getCurrentToken, getCurrentTokenWithoutRedirect, getOxygenId } from '@adsk/acs-sc-web-platform-api';
import { useSWRAlloy, CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
/**
 * Context for current user subscriptions.
 */
const SubscriptionsContext = getOrCreateGlobalContext(CONTEXT_NAMES.SubscriptionsContext);
const useSubscriptionsContext = () => useContextWithValidation(SubscriptionsContext, {
  hook: 'useSubscriptions',
  provider: 'SubscriptionsProvider'
});
export const useSubscriptions = function () {
  let enable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const _useSubscriptionsCont = useSubscriptionsContext(),
    {
      setEnabled
    } = _useSubscriptionsCont,
    rest = _objectWithoutProperties(_useSubscriptionsCont, _excluded);
  useEffect(() => {
    if (enable && setEnabled) {
      setEnabled(true);
    }
  }, [setEnabled, enable]);
  return rest;
};
const fetchSubscriptions = () => getCurrentToken().then(_ref => {
  let {
    accessToken
  } = _ref;
  const oxygenId = getOxygenId(accessToken);
  return fetchWithTokenAndRegion("".concat(getAdminApiUrl(), "/internal/v1/users/").concat(oxygenId, "/subscriptions?filter[status]=active,expired"));
});
export const SubscriptionsProvider = _ref2 => {
  let {
    children
  } = _ref2;
  const [enabled, setEnabled] = useState(false);
  const {
    data: fetchData,
    error,
    revalidate: retry
  } = useSWRAlloy(enabled ? '/current_user_subscriptions' : null, () => getCurrentTokenWithoutRedirect().then(() => fetchSubscriptions()));
  const data = (error === null || error === void 0 ? void 0 : error.status) === 401 ? null : fetchData;
  const loading = !data && !error;
  return /*#__PURE__*/React.createElement(SubscriptionsContext.Provider, {
    value: {
      error,
      loading,
      data: data === null || data === void 0 ? void 0 : data.results,
      retry,
      setEnabled: enabled ? undefined : setEnabled
    }
  }, children);
};
SubscriptionsProvider.displayName = 'SubscriptionsProvider';
SubscriptionsProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node
};
//# sourceMappingURL=SubscriptionsContext.js.map